<template>
  <div class="app-personal-data-form">
    <SimonModal
      :is-visible="showModal"
      @hide="back"
      id="change-customer-data-modal"
      disabled-close
      hidden-close-button
      @shown="onModalShown"
      show-footer-buttons
      @btnLeft="back"
      @btnRight="next"
      :disabled-btn-right="loading_"
      size="large"
      btn-right-title="Speichern"
    >
      <template v-slot:modalTitle>
        <slot name="headerModal">Deine Kundendaten</slot>
      </template>
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
      <div class="form-wrapper">
        <b-form
          :id="'form' + _uid"
          :novalidate="true"
          class="personal-data-input-form"
          data-form-checkout-personal-data-input
          ref="form">
          <b-row>
            <b-col :class="['pr-0', 'pr-md-2']" md="" sm="12">
              <b-form-group>
                <label for="firstName">
                  <slot name="firstNameLabel">Vorname</slot>
                </label>
                <b-form-input
                  name="firstName"
                  id="firstName"
                  type="text"
                  :value="currentCustomer_.firstName"
                  :disabled="true"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col :class="['pr-0', 'pr-md-2']" md="" sm="12">
              <b-form-group class="disabled">
                <label for="lastName">
                  <slot name="lastNameLabel">Nachname</slot>
                </label>
                <b-form-input
                  name="lastName"
                  id="lastName"
                  type="text"
                  :value="currentCustomer_.lastName"
                  :disabled="true"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col :class="['pr-0']" md="4" sm="12">
              <b-form-group class="disabled">
                <label for="birthDate">
                  <slot name="birthDateLabel">Geburtsdatum</slot>
                </label>
                <b-form-input
                  id="birthDate"
                  :key="'birthDateInputField' + refreshKeyBirthDate"
                  :value="currentCustomer_.birthDate"
                  name="birthDate"
                  type="text"
                  :disabled="true"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col :class="['pr-0', 'pr-sm-2']" sm="8">
              <b-form-group :class="vflowGetFeedbackClasses('currentCustomer_.address.street')" class="street-group mandatory">
                <label for="street">
                  <slot name="streetLabel">Strasse</slot>
                </label>
                <b-form-input
                  @blur="vflowInputBlurred('currentCustomer_.address.street')"
                  @focus="vflowInputFocused('currentCustomer_.address.street'); clearErrors()"
                  @input="$v.currentCustomer_.address.street.$touch"
                  name="street"
                  id="street"
                  required
                  type="text"
                  v-model="currentCustomer_.address.street"
                  autocomplete="off"
                  placeholder=""
                ></b-form-input>
                <b-form-invalid-feedback>
                  <slot name="txtInvalidLengthLiveFeedback" v-if="!$v.currentCustomer_.address.street.maxLength">
                    Diese Eingabe hat nicht die richtige Länge.
                  </slot>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col :class="['pr-0']" sm="4">
              <b-form-group :class="vflowGetFeedbackClasses('currentCustomer_.address.houseNumber')" class="houseno-group mandatory">
                <label for="houseNumber">
                  <slot name="houseNumberLabel">Nummer</slot>
                </label>
                <b-form-input
                  @blur="vflowInputBlurred('currentCustomer_.address.houseNumber')"
                  @focus="vflowInputFocused('currentCustomer_.address.houseNumber'); clearErrors()"
                  @input="$v.currentCustomer_.address.houseNumber.$touch"
                  name="houseNumber"
                  id="houseNumber"
                  required
                  type="text"
                  v-model="currentCustomer_.address.houseNumber"
                  ref="houseNumberInputField"
                ></b-form-input>
                <b-form-invalid-feedback>
                  <slot name="txtInvalidLengthLiveFeedback" v-if="!$v.currentCustomer_.address.houseNumber.maxLength && $v.currentCustomer_.address.houseNumber.isValidHouseNo">
                    Diese Eingabe hat nicht die richtige Länge.
                  </slot>
                  <slot name="txtInvalidHousenoLiveFeedback" v-if="!$v.currentCustomer_.address.houseNumber.isValidHouseNo">
                    Dies ist keine gültige Hausnummer.
                  </slot>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col :class="['pr-0', 'pr-sm-2']" sm="4">
              <b-form-group :class="vflowGetFeedbackClasses('currentCustomer_.address.zip')" class="zip-group mandatory">
                <label for="zip">
                  <slot name="zipLabel">PLZ</slot>
                </label>
                <b-form-input
                  @blur="vflowInputBlurred('currentCustomer_.address.zip')"
                  @focus="vflowInputFocused('currentCustomer_.address.zip'); clearErrors()"
                  @input="$v.currentCustomer_.address.zip.$touch"
                  name="zip"
                  id="zip"
                  required
                  type="text"
                  v-model="currentCustomer_.address.zip"
                  ref="zipInputField"
                ></b-form-input>
                <b-form-invalid-feedback>
                  <slot name="txtInvalidZipLiveFeedback" v-if="!$v.currentCustomer_.address.zip.isValidZipCode">
                    Dies ist keine gültige PLZ.
                  </slot>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col :class="['pr-0']" sm="8">
              <b-form-group :class="vflowGetFeedbackClasses('currentCustomer_.address.city')" class="city-group mandatory">
                <label for="city">
                  <slot name="cityLabel">Ort</slot>
                </label>
                <b-form-input
                  @blur="vflowInputBlurred('currentCustomer_.address.city')"
                  @focus="vflowInputFocused('currentCustomer_.address.city'); clearErrors()"
                  @input="$v.currentCustomer_.address.city.$touch"
                  :formatter="formatterCharFilterOnlyAplha"
                  name="city"
                  id="city"
                  required
                  type="text"
                  v-model="currentCustomer_.address.city"
                ></b-form-input>
                <b-form-invalid-feedback>
                  <slot name="txtInvalidLengthLiveFeedback" v-if="!$v.currentCustomer_.address.city.maxLength">
                    Diese Eingabe hat nicht die richtige Länge.
                  </slot>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col :class="['pr-0']">
              <b-form-group :class="vflowGetFeedbackClasses('currentCustomer_.address.supplement')"
                            class="supplement-group">
                <label for="supplement">
                  <slot name="supplementLabel">Adresszusatz</slot>
                </label>
                <b-form-input
                  @blur="vflowInputBlurred('currentCustomer_.address.supplement')"
                  @focus="vflowInputFocused('currentCustomer_.address.supplement'); clearErrors()"
                  @input="$v.currentCustomer_.address.supplement.$touch"
                  name="supplement"
                  id="supplement"
                  type="text"
                  v-model="currentCustomer_.address.supplement"
                ></b-form-input>
                <b-form-invalid-feedback>
                  <slot name="txtInvalidLengthLiveFeedback" v-if="!$v.currentCustomer_.address.supplement.maxLength">
                    Diese Eingabe hat nicht die richtige Länge.
                  </slot>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="error-box" v-html="getBackendErrorMessage" v-if="showFailedValidationError">
            Ufff! Kannst du bitte noch einmal deine Dateneingabe checken? Die angegebene Adresse ist leider nicht
            bekannt und ich will sicherstellen, dass deine SIM-Karte auch bei dir ankommt. (Fehler: 205)
          </div>
          <div class="error-box" v-if="hasAutocompleteError">
            <slot name="txtGoogleAutocompleteError">
              Ufff! Es ist leider ein Fehler bei der automatischen Befüllung deiner Adressdaten aufgetreten (Fehler: GA1). Bitte gib deine Adresse manuell ein.
            </slot>
          </div>
          <b-row>
            <b-col :class="['pr-0']">
              <b-form-group :class="vflowGetFeedbackClasses('currentCustomer_.email')" class="email-group mandatory">
                <label for="email">
                  <slot name="emailLabel">E-Mail Adresse</slot>
                </label>
                <b-form-input
                  @blur="vflowInputBlurred('currentCustomer_.email')"
                  @focus="vflowInputFocused('currentCustomer_.email'); clearErrors()"
                  @input="$v.currentCustomer_.email.$touch"
                  name="email"
                  id="email"
                  required
                  type="email"
                  v-model="currentCustomer_.email"
                ></b-form-input>
                <b-form-invalid-feedback>
                  <slot name="txtInvalidEmailLiveFeedback">
                    Dies ist keine gültige E-Mail-Adresse.
                  </slot>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col :class="['pr-0']">
              <b-form-group :class="vflowGetFeedbackClasses('currentCustomer_.alternativePhone')" class="phone-group">
                <label for="phone">
                  <slot name="phoneLabel">Kontakt-Rufnummer</slot>
                </label>
                <b-form-input
                  :value="currentCustomer_.alternativePhone"
                  @blur="vflowInputBlurred('currentCustomer_.alternativePhone')"
                  @focus="vflowInputFocused('currentCustomer_.alternativePhone'); clearErrors()"
                  @input="formatPhoneNumber"
                  name="phone"
                  id="phone"
                  ref="phoneInputField"
                  type="tel"
                ></b-form-input>
                <b-form-invalid-feedback>
                  <slot name="txtInvalidPhoneLiveFeedback">
                    Dieses ist keine gültige Rufnummer.
                  </slot>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
        <MessageModal></MessageModal>
      </div>
    </SimonModal>
  </div>
</template>

<script>
import { BCol, BForm, BFormGroup, BFormInput, BRow } from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/validators/isValid'
import date from '@/mixins/validators/date'
import syncProperty from '@/mixins/syncProperty'
import { maxLength, required } from 'vuelidate/lib/validators'
import emailValidator from '@/mixins/validators/emailValidator'
import logout from '@/mixins/logout'

import transaction from '@/mixins/transaction'
import { isValidPhoneExtIfNotEmpty } from '@/mixins/validators/phone'
import validationFlow from '@/mixins/validators/validationFlow'
import beErrors from '@/mixins/beErrors'
import formatterCharFilterOnlyAplha from '@/mixins/formatters/inputFormatter'
import formatDecimal from '@/mixins/formatters/formatDecimal'
import { mapActions } from 'vuex'
import MessageModal from '@/components/generic/MessageView/MessageList.vue'
import googleAutocomplete from '@/mixins/googleAutocomplete'
import { phoneFormatter } from '@/mixins/formatters/phoneFormatter'
import SimonModal from '@/components/modal/SimonModal.vue'

const zipValidator = /^\d{5}$/
const isValidZipCode = (v) => zipValidator.test(v)
const houseNoValidator = /^(\d{1,5})$|^(\d{1,4}([a-zA-Z]))$|^(((\d{1,5})|(\d{1,4}([a-zA-Z])))-((\d{1,5})|(\d{1,4}([a-zA-Z]))||([a-zA-Z])))$/
const isValidHouseNo = (v) => houseNoValidator.test(v)

export const stepName = 'changePersonalData'

const initialCustomerState = {
  salutation: '',
  firstName: '',
  lastName: '',
  birthDate: '',
  address: {
    city: '',
    houseNumber: '',
    street: '',
    supplement: '',
    zip: ''
  },
  alternativePhone: '',
  email: '',
  emailVerified: false
}

export default {
  name: 'PersonalDataFormModal',
  data () {
    return {
      currentCustomer_: initialCustomerState,
      loadedCurrentCustomer: false,
      showFailedValidationError: false,
      showTechnicalError: false,
      refreshKeyBirthDate: 0,
      refreshKeyDifferentBirthDate: 5000,
      updateBirthDate: false,
      updateDifferentBirthDate: false,
      hasAutocompleteError: false
    }
  },
  components: {
    SimonModal,
    MessageModal,
    BFormInput,
    BRow,
    BCol,
    BFormGroup,
    BForm
  },
  props: {
    max50: {
      type: Number,
      default: 50
    },
    max9: {
      type: Number,
      default: 9
    },
    disableChangeNameAndBirthdate: {
      type: Boolean,
      default: true
    },
    currentCustomer: {
      type: Object
    },
    showToast: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    '$v.$invalid': {
      immediate: true,
      handler: function (newValue) {
        this.$emit('update:invalid', newValue)
      }
    }
  },
  mixins: [
    transaction('personalData'),
    validationMixin,
    isValid,
    date,
    emailValidator,
    logout,
    syncProperty('show', 'showModal'),
    syncProperty('loading', 'loading_'),

    validationFlow,
    beErrors,
    formatterCharFilterOnlyAplha,
    formatDecimal,
    googleAutocomplete()
  ],
  mounted () {
    this.$v.$reset()
  },
  methods: {
    ...mapActions('personalDataChange', [
      'changePersonalData'
    ]),
    onModalShown () {
      this.$store.commit('clearMessages', {}, { root: true })
      this.currentCustomer_ = this.currentCustomer
      this.initiateAutocomplete(this.autocompleteCallback)
    },
    setCursorPosition (el, pos) {
      el.focus()
      el.setSelectionRange(pos, pos)
    },
    clearErrors () {
      this.showFailedValidationError = false
      this.showTechnicalError = false
      this.$store.commit('clearMessages', {}, { root: true })
    },
    formatPhoneNumber (pv) {
      const v = (typeof pv !== 'undefined') ? pv : this.currentCustomer_.alternativePhone
      // handle value-edit event
      if (this.$refs.phoneInputField.selectionStart < v.length) {
        const startPos = this.$refs.phoneInputField.selectionStart
        this.currentCustomer_.alternativePhone = phoneFormatter(v)
        this.$v.currentCustomer_.alternativePhone.$touch()
        this.$nextTick(() => this.setCursorPosition(this.$refs.phoneInputField, startPos))
        return
      }

      this.currentCustomer_.alternativePhone = phoneFormatter(v)
      this.$v.currentCustomer_.alternativePhone.$touch()
    },
    next () {
      this.$v.$touch()
      this.loading_ = true
      this.vflowForceFeedback()

      if (!this.$v.currentCustomer_.$invalid) {
        this.startLoader()

        this.changePersonalData(this.currentCustomer_)
          .then((response) => {
            if (response === 'success') {
              this.showModal = false
              if (this.showToast) {
                this.successToast(
                  this.$slots.txtPersonalDataSaved
                    ? this.$slots.txtPersonalDataSaved[0].text
                    : 'Die Daten wurden erfolgreich gespeichert.'
                )
              }
              this.$emit('after-success', this.currentCustomer_)
            }
            this.$emit('after-change', this.currentCustomer_)
            this.loading_ = false
          })
          .catch(() => {
            this.loading_ = false
            this.errorToast('Technical error occurred')
          })
          .finally(() => {
            this.stopLoader()
          })
      } else {
        this.loading_ = false
        // Ensure live feedback for validation errors
        this.vFlowGetFirstErrorElementName().then((result) => {
          const data = {
            type: 'validation',
            message: 'required field missing',
            location: result + ' - unknown'
          }
          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('error', data)
          }
        })
      }
    },
    back () {
      this.$store.commit('clearMessages', {}, { root: true })
      this.$emit('cancel')
      this.showModal = false
    },
    autocompleteCallback () {
      this.setupAutocompleteHandler(document.getElementById('street'), document.getElementById('change-customer-data-modal'))
    },
    performAutocomplete () {
      this.currentCustomer_.address.zip = ''
      this.currentCustomer_.address.houseNumber = ''
      this.currentCustomer_.address.city = ''
      this.currentCustomer_.address.street = ''
      this.hasAutocompleteError = false
      const place = this.autocompleteHandler.getPlace()
      // Get each component of the address from the place details,
      // and then fill-in the corresponding field on the form.
      // place.address_components are google.maps.GeocoderAddressComponent objects
      // which are documented at http://goo.gle/3l5i5Mr
      if (place.address_components === undefined || place.address_components.length <= 0) {
        this.hasAutocompleteError = true
        return
      }
      for (const component of place.address_components) {
        const componentType = component.types[0]

        switch (componentType) {
          case 'street_number': {
            this.currentCustomer_.address.houseNumber = component.long_name
            break
          }
          case 'postal_code': {
            this.currentCustomer_.address.zip = component.long_name
            break
          }
          case 'locality': {
            this.currentCustomer_.address.city = component.long_name
            break
          }
          case 'route': {
            // Add short delay on rout to avoid race conditions with google autocomplete
            const _this = this
            setTimeout(() => { _this.currentCustomer_.address.street = component.long_name }, 5)
            break
          }
        }
      }
      if (this.currentCustomer_.address.houseNumber === '') {
        this.$refs.houseNumberInputField.$el.focus()
      } else if (this.currentCustomer_.address.zip === '') {
        this.$refs.zipInputField.$el.focus()
      }
    }
  },
  validations () {
    return {
      currentCustomer_: {
        email: {
          required,
          // due to case-sensitive domain validation (see https://github.com/vuelidate/vuelidate/issues/753)
          emailCI (v) {
            return this.validateEmail(v.toLowerCase())
          }
        },
        alternativePhone: {
          isValidPhoneExtIfNotEmpty
        },
        address: {
          street: {
            required,
            maxLength: maxLength(this.max50)
          },
          houseNumber: {
            required,
            maxLength: maxLength(this.max9),
            isValidHouseNo
          },
          zip: {
            required,
            isValidZipCode
          },
          city: {
            required,
            maxLength: maxLength(this.max50)
          },
          supplement: {
            maxLength: maxLength(this.max50)
          }
        }
      }
    }
  }
}
</script>
